// extracted by mini-css-extract-plugin
module.exports = {"container":"RichContent_container__3USVy","img":"RichContent_img__3LWFi"};